import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1b20650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card card-flex card-outline card-themes" }
const _hoisted_5 = {
  class: "card-body table-responsive p-0",
  style: {"background-color":"#f5f6f6"}
}
const _hoisted_6 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_7 = {
  key: 0,
  class: "err-info"
}
const _hoisted_8 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "dialog-header-btn" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("XML")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("JSON")

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_flowable_layout_header_setting = _resolveComponent("flowable-layout-header-setting")
  const _component_flowable_layout_base_setting = _resolveComponent("flowable-layout-base-setting")
  const _component_flowable_layout_form_setting = _resolveComponent("flowable-layout-form-setting")
  const _component_flowable_layout_process_design = _resolveComponent("flowable-layout-process-design")
  const _component_flowable_layout_pro_setting = _resolveComponent("flowable-layout-pro-setting")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_Loading = _resolveComponent("Loading")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_Warning = _resolveComponent("Warning")
  const _component_app_ellipsis = _resolveComponent("app-ellipsis")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_result = _resolveComponent("el-result")
  const _component_app_dialog = _resolveComponent("app-dialog")
  const _component_Codemirror = _resolveComponent("Codemirror")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_flowable_layout_header_setting, {
            modelValue: _ctx.activeSelect,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.activeSelect) = $event)),
            onPublish: _ctx.publishProcess,
            onPreview: _ctx.preview,
            onViewXml: _ctx.viewXml
          }, null, 8, ["modelValue", "onPublish", "onPreview", "onViewXml"]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createVNode(_component_flowable_layout_base_setting, { ref: "baseSetting" }, null, 512), [
              [_vShow, _ctx.activeSelect === 'baseSetting']
            ]),
            _withDirectives(_createVNode(_component_flowable_layout_form_setting, { ref: "formSetting" }, null, 512), [
              [_vShow, _ctx.activeSelect === 'formSetting']
            ]),
            _withDirectives(_createVNode(_component_flowable_layout_process_design, { ref: "processDesign" }, null, 512), [
              [_vShow, _ctx.activeSelect === 'processDesign']
            ]),
            _withDirectives(_createVNode(_component_flowable_layout_pro_setting, { ref: "proSetting" }, null, 512), [
              [_vShow, _ctx.activeSelect === 'proSetting']
            ])
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_app_dialog, {
      showFooter: false,
      modelValue: _ctx.validVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.validVisible) = $event)),
      title: "设置项检查"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_steps, {
          "align-center": "",
          active: _ctx.validStep,
          "finish-status": "success",
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validOptions, (step, i) => {
              return (_openBlock(), _createBlock(_component_el_step, {
                title: step.title,
                key: i,
                icon: step.icon,
                status: step.status,
                description: step.description
              }, null, 8, ["title", "icon", "status", "description"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["active"]),
        _createVNode(_component_el_result, {
          icon: _ctx.validIcon,
          title: _ctx.errTitle,
          subTitle: _ctx.validResult.desc
        }, {
          icon: _withCtx(() => [
            (!_ctx.validResult.finished)
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  style: {"font-size":"30px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Loading)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          "sub-title": _withCtx(() => [
            (_ctx.validResult.errs.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validResult.errs, (err, i) => {
                    return (_openBlock(), _createBlock(_component_app_ellipsis, {
                      "hover-tip": "",
                      key: i + '_err',
                      content: err
                    }, {
                      pre: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: "1em" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Warning)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          extra: _withCtx(() => [
            (_ctx.validResult.finished)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "default",
                  onClick: _ctx.doAfter
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.validResult.action), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["icon", "title", "subTitle"]),
        (_ctx.isLoading1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_svg_icon, {
                name: "ali-loading",
                size: "xl",
                class: "turn"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_app_dialog, {
      customHeader: true,
      showFooter: false,
      modelValue: _ctx.xmlFlowVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.xmlFlowVisible) = $event))
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("h4", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.viewTitle), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "default",
              disabled: _ctx.viewCodeType==='xml',
              onClick: _cache[2] || (_cache[2] = $event => {_ctx.viewCodeType='xml'; _ctx.viewTitle='查看XML';})
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "default",
              disabled: _ctx.viewCodeType==='json',
              onClick: _cache[3] || (_cache[3] = $event => {_ctx.viewCodeType='json'; _ctx.viewTitle='查看JSON';})
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 10, _hoisted_9)
      ]),
      default: _withCtx(() => [
        (_ctx.viewCodeType==='xml')
          ? (_openBlock(), _createBlock(_component_Codemirror, {
              key: 0,
              value: _ctx.xmlFlowValue.xml,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => ((_ctx.xmlFlowValue.xml) = $event)),
              options: _ctx.xmlOptions,
              border: "",
              width: "100%",
              height: "50em",
              style: {"font-size":"14px"}
            }, null, 8, ["value", "options"]))
          : _createCommentVNode("", true),
        (_ctx.viewCodeType==='json')
          ? (_openBlock(), _createBlock(_component_Codemirror, {
              key: 1,
              value: _ctx.jsonCode,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => ((_ctx.jsonCode) = $event)),
              options: _ctx.jsonOptions,
              border: "",
              width: "100%",
              height: "50em",
              style: {"font-size":"14px"}
            }, null, 8, ["value", "options"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}